import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { combineLatest, filter, interval, timer } from 'rxjs';
import { ErrorService } from './error.service';
import { AuthStore, AuthStoreType } from '../stores/auth.store';

const COUNTDOWN_SEGUNDOS = 60;

@Injectable()
export class ActualizadorService {
  private updates = inject(SwUpdate);
  private errorService = inject(ErrorService);
  private authStore: AuthStoreType = inject(AuthStore);

  private _tickId: ReturnType<typeof setInterval> | null = null;

  constructor() {
    this._escucharVersionLista();
    this._iniciarComprobacionPeriodica();
  }

  // ── Escucha eventos VERSION_READY y lanza el modal de actualización ─────────

  private _escucharVersionLista(): void {
    this.updates.versionUpdates
      .pipe(filter((e): e is VersionReadyEvent => e.type === 'VERSION_READY'))
      .subscribe(() => this._mostrarModalActualizacion());
  }

  // ── Comprobar actualizaciones cada minuto (tras 5s de arranque) ─────────────

  private _iniciarComprobacionPeriodica(): void {
    combineLatest([interval(60_000), timer(5_000)]).subscribe(() => {
      this.updates
        .checkForUpdate()
        .catch((e) => this.errorService.log('ActualizadorService checkForUpdate:', e));
    });
  }

  // ── Modal con botón + countdown de 60s ────────────────────────────────────

  private _mostrarModalActualizacion(): void {
    let restantes = COUNTDOWN_SEGUNDOS;

    this.authStore.showBlockuiConBoton(this._mensajeContador(restantes), 'Actualizar ahora', () =>
      this._ejecutarActualizacion()
    );

    this._tickId = setInterval(() => {
      restantes--;
      if (restantes > 0) {
        this.authStore.setBlockuiMensaje(this._mensajeContador(restantes));
      } else {
        this._ejecutarActualizacion();
      }
    }, 1_000);
  }

  private _ejecutarActualizacion(): void {
    if (this._tickId !== null) {
      clearInterval(this._tickId);
      this._tickId = null;
    }
    this.updates.activateUpdate().finally(() => window.location.reload());
  }

  private _mensajeContador(seg: number): string {
    return `Nueva versión disponible. Actualizando en ${seg} segundo${seg !== 1 ? 's' : ''}...`;
  }
}
